const YouTubeEmbed = () => {
  return (
    <section className="flex justify-center items-center m-12">
      <div className="w-full max-w-3xl">
        <iframe
          className="w-full aspect-video rounded-lg shadow-lg"
          src="https://www.youtube.com/embed/eKXEnokwxOw?si=LyhjH3vynTrqQq5o"
          title="YouTube video"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

export default YouTubeEmbed;
